import React from "react";
import CustomTable from "./CustomTable";

function PayoutsTable({ columnsValues, dataValues, isFirstColSticky }) {
  return (
    <div className="payoutsTableContainer">
      <CustomTable
        data={dataValues || []}
        columns={columnsValues || [{}]}
        isFirstColSticky={isFirstColSticky}
      />
    </div>
  );
}

export default PayoutsTable;
